var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.switchLocale()}}},[(_vm.selectedLanguage === 'en')?_c('span',[_vm._v("FR")]):_c('span',[_vm._v("EN")])])])}
var staticRenderFns = []

export { render, staticRenderFns }